module.exports = __webpack_public_path__ + "static/media/mision.80cf524b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/mision.svg
// module id = 182
// module chunks = 0